// Server-driven search results. Unlike the other slices these are NOT filters and have no
// entry in DEFAULT_STATE / buildSearchParams - they hold the response of the listing JSON
// endpoint (data/meta/filtersOptions/tags) plus request status, seeded from SSR on mount.
// itemListId/gaList are the analytics list names the backend derives for the result set
// (ListingPageFiltersHelper#filter_info). gaAttributesById holds the per-item GA attributes from
// /listing_page/tracking_info, and trackingInfoIds the result ids they were fetched for.
export const initialResultsState = {
  results: [],
  meta: {},
  filtersOptions: {},
  filterCounts: {},
  resultTags: [],
  isLoading: false,
  fetchError: null,
  page: 1,
  itemListId: '',
  gaList: '',
  gaAttributesById: {},
  trackingInfoIds: '',
}
